import { render, staticRenderFns } from "./PrivatePlotCard.vue?vue&type=template&id=ef6148e2&scoped=true&"
import script from "./PrivatePlotCard.vue?vue&type=script&lang=js&"
export * from "./PrivatePlotCard.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePlotCard.vue?vue&type=style&index=0&id=ef6148e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6148e2",
  null
  
)

export default component.exports